import img1 from '../Images/bike_image1.jpg';
import img2 from '../Images/bike_image2.webp';
import img3 from '../Images/bike_image3.jfif';
import img4 from '../Images/bike_image4.jfif';
import img5 from '../Images/bike_image5.jfif';
import img6 from '../Images/bike_image6.jfif';
import img7 from '../Images/bike_image7.jfif';
import img8 from '../Images/bike_image8.jfif';
import img9 from '../Images/bike_image9.jfif';


const BikeData = {
    productData:[
        {
            id:1,
            img:img1,
            title:'Duke 250',
            desc:'Engine Displ: 248.8 cc Max Power: 30 PS @ 9000 rpm Mileage: 41 kmpl Fuel Type: Petrol helps youbto rule the road and in amazing condition',
            price: 50000,
        },
        {
            id:2,
            img:img2,
            title:'Hero Pleasure Plus Platinum',
            desc:'It is powered by 110.9 cc engine and puts a power of 8.1 PS sleek design easy to handle with an amazing colour finish',
            price:70000,
        },
        {
            id:3,
            img:img3,
            title:'Pulsar',
            desc:'A pulsar is a highly magnetized rotating compact star With an awesome metallic black finish and an excellent customised look',
            price:40000,
        },
        {
            id:4,
            img:img4,
            title:'TVS Apache',
            desc:'Engine TypeSI, 4- stroke, Air- CooledNo. of Cylinders1Max Power15.53 PS @ 8400 rpmMax Torque13 useful to achieve top speed faster',
            price:75000,
        },
        {
            id:5,
            img:img5,
            title:'Suzuki Access',
            desc:'This Access 125 engine generates a power of 8.7 PS @ 6750 rpm and a torque of 10 Nm @ 5500 rpm. The claimed mileage of Access 125 is 57.2 2 kmpl.',
            price: 55000 ,
        },
        {
            id:6,
            img:img6,
            title:'RX 100',
            desc:'Engine 98.2 cc (5.99 cu in) air-cooled, reed valve two-stroke single.Top speed 110kmph+ gives you a vintage feel of riding',
            price: 40000,
        },
        {
            id:7,
            img:img7,
            title:'Yamaha FZ25',
            desc:'Engine249 cc	197.7 cc. Max Power	20.6 bhp @ 8000 rpm	20.7 bhp @ 8500 rpm with a matt black finish and modified tank scoop',
            price:80000,
        },
        {
            id:8,
            img:img8,
            title:'TVS Jupiterl',
            desc:'Engine Type Single cylinder, 4 stroke, CVTi, fuel injection. No. of Cylinders 1 with an extended body for better comfort',
            price:50000,
        },
        {
            id:9,
            img:img9,
            title:'Honda Dio',
            desc:'Engine Displ : 109.51 cc. Brakes Front :	Drum. Max Power : 7.76 PS @ 8000 rpm. Kerb Weight :	103 Kg dazzling yellow colour',
            price:65000,
        },
    ],
};

export default BikeData;